import React, { useContext, useEffect } from "react";
import dynamic from "next/dynamic";
import { Box } from "@mui/material";
import Namaste from "@public/assets/Lottie/namaste-home.json";
import classesWM from "../styles/welcomeModal.module.css";
import TopCorner from "@public/assets/icons/LoginTopCorner.svg";
import LoginBottom from "@public/assets/icons/LoginBottom.svg";
import Modal from "@mui/material/Modal";
import { Store } from "@utils/store/ContextStore";
import { useTranslation } from "react-i18next";
const Lottie = dynamic(() => import("lottie-react"), {
  ssr: false
});
const WelcomeModal = ({
  open,
  onClose
}) => {
  const {
    t
  } = useTranslation();
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 2000);
    return () => clearTimeout(timer);
  }, [onClose]);

  //console.log("loggedInUser", loggedInUser);
  return <Modal open={open} onClose={onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" data-sentry-element="Modal" data-sentry-component="WelcomeModal" data-sentry-source-file="welcomeModal.jsx">
      <Box className={classesWM.boxStyle} data-sentry-element="Box" data-sentry-source-file="welcomeModal.jsx">
        <div className={classesWM.welcomeSec}>
          <div className={classesWM.welMiddleSec}>
            <Lottie animationData={Namaste} loop={true} className={classesWM.lottie} data-sentry-element="Lottie" data-sentry-source-file="welcomeModal.jsx" />
            <div className={classesWM.namasteMsg}>
              <div className={classesWM.Namaste}>
                {t('namaste')} {loggedInUser.name}!
              </div>
              <div className={classesWM.Welcome}>{t('welcome-to-utsav')}</div>
            </div>
          </div>
          <div className={classesWM.topCorner}>
            <TopCorner data-sentry-element="TopCorner" data-sentry-source-file="welcomeModal.jsx" />
          </div>
          <div className={classesWM.bottom}>
            <LoginBottom data-sentry-element="LoginBottom" data-sentry-source-file="welcomeModal.jsx" />
          </div>
        </div>
      </Box>
    </Modal>;
};
export default WelcomeModal;